import { showToast } from 'react/toasts/showToast';
import { __ } from 'i18n/index';

// Copies text. A caller with a control on screen passes onSuccess and flips its
// own label ("✓ Copied"); without one, a toast says so.
export function copyToClipboard(text, onSuccess = null) {
	const refused = () => showToast({ kind: 'warning', content: __("Couldn't copy to your clipboard") });
	if(!navigator.clipboard) {
		refused();
		return Promise.resolve();
	}
	return navigator.clipboard.writeText(text).then(() => {
		if(onSuccess) {
			onSuccess(text);
		}
		else {
			showToast({ content: __('Copied') });
		}
	}, refused);
}
